import React from "react";
import Section from "../components/Section";

function DataRetention() {
  return (
    <Section id="data-retention" icon="🗄️" title="Data Retention">
      <p>
        We retain data only for as long as necessary to fulfil the purposes described in this policy:
      </p>
      <ul>
        <li>
          <strong>Analytics data</strong> — retained for up to 14 months in accordance with
          Google Firebase and AppCenter default retention settings, after which it is automatically deleted.
        </li>
        <li>
          <strong>Crash reports</strong> — retained for up to 90 days and then purged.
        </li>
        <li>
          <strong>Push notification tokens</strong> — retained while the App is installed on your device.
          Uninstalling the App removes the token from active use.
        </li>
        <li>
          <strong>Food reviews and photos you submit</strong> — retained until you delete them within
          the App, or until you request deletion by contacting us.
        </li>
      </ul>
    </Section>
  );
}

export default DataRetention;
